import React from 'react';
import { DealColumn } from './deal-list-column';
import styled from 'styled-components';
import Grid, { GridProps } from '@webapp/components/basics/grid';

interface DealGridProps extends GridProps {
  columns: DealColumn[];
  isMobile: boolean;
  children?: React.ReactNode;
  onClick?: () => void;
}

export const DealGrid: React.FC<DealGridProps> = ({
  columns,
  isMobile,
  ...props
}) => {
  return <Grid {...props} />;
};

const getColSize = (
  pos: number,
  columns: DealColumn[],
  key: 'size' | 'laptopSize'
) => {
  const cols = columns.filter((_, i) => i < pos);
  const prevSize = cols.reduce((m, c) => m + (c[key] || 1), 0);

  const start = (pos || 1) + prevSize;
  const end = (pos || 1) + prevSize + (columns[pos][key] || 1);

  return `${start} / ${end}`;
};

const getGridTemplate = (columns: DealColumn[], gap: number) => {
  const totalSize = columns.reduce((m, c) => m + (c.size || 1), 0);
  return `repeat(${totalSize}, calc(${100 / totalSize}% - ${gap}px))`;
};

export default styled(DealGrid)`
  grid-template-columns: ${({ columns }) => getGridTemplate(columns, 15)};
  grid-gap: 15px;
  align-items: center;

  ${({ columns }) =>
    columns.map(
      (c, i) => `
    .col-${c.key} {
      grid-column: ${getColSize(i, columns, 'size')};
      ${c.type === 'number' ? `text-align: right;` : ''}
    }
  `
    )}

  // ${({ theme }) => `@media screen and ${theme.device.laptop}`} {
  //   ${({ columns }) =>
    columns.map(
      (c, i) => `
  //     .col-${c.key} {
  //       grid-column: ${getColSize(i, columns, 'laptopSize')};
  //     }
  //   `
    )}
  // }
`;
